'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Gdata = function () {
    function Gdata() {
        _classCallCheck(this, Gdata);

        window._gdata_ = window._gdata_ || {};
    }

    Gdata.prototype.get = function get(key) {
        return window._gdata_[key];
    };

    Gdata.prototype.set = function set(key, value) {
        if (typeof key === 'string') {
            window._gdata_[key] = value;
        } else {
            _extends(window._gdata_, key);
        }
    };

    return Gdata;
}();

var gdata = new Gdata();

exports['default'] = gdata;
module.exports = exports['default'];